import React from 'react';
import { Query } from 'react-apollo';
import userDropDownQuery from './UserDropDown.graphql';
import getUserLinks from './getUserLinks';

export const userDataQuery = (
  lang,
  isEUDC,
  renderUserData,
  renderUserDataError = renderUserData
) => {
  return (
    <Query query={userDropDownQuery}>
      {({ loading, error, data }) => {
        if (loading) return null;
        if (error) {
          const username = 'My Account';
          const userLinks = getUserLinks();
          return renderUserDataError(username, userLinks);
        }
        const { username, preferences, features } = data.user;
        const teamMembership = data.user.teamMembership || {};
        const isTeamOwner = teamMembership.memberType === 'ACCOUNT_OWNER';
        const isEnterpriseAccount = teamMembership.isEnterprise;
        const isNonEnterpriseGroupAdmin = !isEnterpriseAccount && isTeamOwner;
        const { paidBenchmarksEnabled } = preferences;
        const liteLibraryEnabled = features && features.liteLibraryEnabled;
        const plansBenchmarksEnabled =
          features && features.plansBenchmarksEnabled;
        const libraryEnabled = teamMembership || liteLibraryEnabled;
        const userLinks = getUserLinks(
          isNonEnterpriseGroupAdmin,
          paidBenchmarksEnabled,
          libraryEnabled,
          plansBenchmarksEnabled,
          isEnterpriseAccount,
          lang,
          isEUDC
        );
        return renderUserData(username, userLinks);
      }}
    </Query>
  );
};

export default userDataQuery;
